/*
 * Account Messages
 *
 * This contains all the text for the AccountModal component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.AccountModal.header',
    defaultMessage: 'My Account',
  },
  created: {
    id: 'app.components.AccountModal.created',
    defaultMessage: 'Account Created',
  },
  email: {
    id: 'app.components.AskEmail.email',
    defaultMessage: 'Email Address',
  },
  premiumUntil: {
    id: 'app.components.AccountModal.premiumUntil',
    defaultMessage: 'Subscription Until',
  },
  thanks: {
    id: 'app.components.AccountModal.thanks',
    defaultMessage: 'Thanks for your support!',
  },
  recurring: {
    id: 'app.components.AccountModal.recurring',
    defaultMessage: 'Your subscription will automatically be extended.',
  },
  cancelRecurring: {
    id: 'app.components.AccountModal.cancelRecurring',
    defaultMessage: 'Cancel',
  },
  confirmCancel: {
    id: 'app.components.AccountModal.confirmCancel',
    defaultMessage: 'Cancel the automatic extension of your subscription?',
  },
  extend: {
    id: 'app.components.AccountModal.extend',
    defaultMessage: 'Extend',
  },
  kmvProfile: {
    id: 'app.components.AccountModal.kmvProfile',
    defaultMessage: 'Mile Eaters Profile',
  },
  stravaProfile: {
    id: 'app.components.AccountModal.stravaProfile',
    defaultMessage: 'Strava Profile',
  },
  M: {
    id: 'app.containers.Virtual.M',
    defaultMessage: 'M',
  },
  F: {
    id: 'app.containers.Virtual.F',
    defaultMessage: 'F',
  },
  V: {
    id: 'app.containers.Virtual.F',
    defaultMessage: 'F',
  },
  private: {
    id: 'app.components.AccountModal.private',
    defaultMessage: '(private)',
  },
  nRoutes: {
    id: 'app.components.AccountModal.nRoutes',
    defaultMessage: 'Aantal routes',
  },
  nPublic: {
    id: 'app.components.AccountModal.nPublic',
    defaultMessage: ', waarvan {count} openbare routes',
  },
  nRaces: {
    id: 'app.components.AccountModal.nRaces',
    defaultMessage: '{count} races',
  },
  supporterText: {
    id: 'app.components.AccountModal.supporterText',
    defaultMessage:
      'Support the further development of RunnerMaps and get a subscription for a better experience',
  },
  supporterAction: {
    id: 'app.components.AccountModal.supporterAction',
    defaultMessage: 'More about the RunnerMaps Subscription',
  },
  paymentOK: {
    id: 'app.components.AccountModal.paymentOK',
    defaultMessage:
      'The payment was successful. A confirmation message has been sent by email.',
  },
  deleteAccount: {
    id: 'app.components.AccountModal.deleteAccount',
    defaultMessage: 'Delete Account',
  },
  deleteAccountTitle: {
    id: 'app.components.AccountModal.deleteAccountTitle',
    defaultMessage: 'Delete Account - Confirmation Required',
  },
  deleteWarning: {
    id: 'app.components.AccountModal.deleteWarning',
    defaultMessage: 'Warning: This action cannot be undone!',
  },
  deleteDataNote: {
    id: 'app.components.AccountModal.deleteDataNote',
    defaultMessage:
      'All your data will be permanently deleted, including: all your routes, kilometervreter runs, testlopen (imported from Strava), and all other associated data.',
  },
  deleteCanLoginAgain: {
    id: 'app.components.AccountModal.deleteCanLoginAgain',
    defaultMessage:
      'Note: After deletion, you can still log in with your email address, Facebook, or Google account, but a new account will be created automatically.',
  },
  publicRoutesWarning: {
    id: 'app.components.AccountModal.publicRoutesWarning',
    defaultMessage:
      'You have {count} public routes. These will also be deleted and will no longer be accessible to anyone.',
  },
  confirmEmailLabel: {
    id: 'app.components.AccountModal.confirmEmailLabel',
    defaultMessage: 'To confirm, please type your email address:',
  },
  confirmPublicRoutes: {
    id: 'app.components.AccountModal.confirmPublicRoutes',
    defaultMessage: 'I confirm deletion of all {count} public routes',
  },
  cancel: {
    id: 'app.components.AccountModal.cancel',
    defaultMessage: 'Cancel',
  },
  deleteSuccess: {
    id: 'app.components.AccountModal.deleteSuccess',
    defaultMessage:
      'Your account has been successfully deleted. You will be redirected to the home page.',
  },
  changeEmailTitle: {
    id: 'app.components.AccountModal.changeEmailTitle',
    defaultMessage: 'Change Email Address',
  },
  changeEmailInfo: {
    id: 'app.components.AccountModal.changeEmailInfo',
    defaultMessage:
      'Enter your new email address. You will receive a confirmation code to verify the change.',
  },
  newEmailLabel: {
    id: 'app.components.AccountModal.newEmailLabel',
    defaultMessage: 'New Email Address',
  },
  requestChange: {
    id: 'app.components.AccountModal.requestChange',
    defaultMessage: 'Request Change',
  },
  pendingEmailChange: {
    id: 'app.components.AccountModal.pendingEmailChange',
    defaultMessage: 'Pending Email Change',
  },
  confirmEmailInfo: {
    id: 'app.components.AccountModal.confirmEmailInfo',
    defaultMessage:
      'A confirmation code has been sent to {email}. Please enter the 6-digit code below.',
  },
  confirmationCodeLabel: {
    id: 'app.components.AccountModal.confirmationCodeLabel',
    defaultMessage: 'Confirmation Code',
  },
  confirmChange: {
    id: 'app.components.AccountModal.confirmChange',
    defaultMessage: 'Confirm Change',
  },
  cancelEmailChange: {
    id: 'app.components.AccountModal.cancelEmailChange',
    defaultMessage: 'Cancel Email Change',
  },
  emailChangeSuccess: {
    id: 'app.components.AccountModal.emailChangeSuccess',
    defaultMessage: 'Your email address has been successfully changed.',
  },
  mergeAccountsQuestion: {
    id: 'app.components.AccountModal.mergeAccountsQuestion',
    defaultMessage: 'An account with this email address already exists, merge both accounts?',
  },
  mergeAccounts: {
    id: 'app.components.AccountModal.mergeAccounts',
    defaultMessage: 'Merge Accounts / Accounts samenvoegen',
  },
  accountsMerged: {
    id: 'app.components.AccountModal.accountsMerged',
    defaultMessage: 'Accounts successfully merged. Please sign in again.',
  },
});
